import {defineStore} from 'pinia'
import {IInvoicing} from "@/interface/services/response/invoicing.interface"

export const useInvoicingStore = defineStore('invoicing', {
    state: (): IInvoicingState => ({
        id: 0,
        street: null,
        streetNumber: null,
        box: null,
        city: null,
        zipCode: null,
        country: null,
        paymentMode: null,
        paymentIban: null,
        paymentBic: null,
        paymentMandateDate: null,
        holderFirstName: null,
        holderLastName: null,
        holderEmail: null,
    }),
    actions: {
        initStoreWithValue(invoicing: IInvoicing) {           
            this.id = invoicing.id
            this.street = invoicing.address.street
            this.streetNumber = invoicing.address.number
            this.box = invoicing.address.box
            this.city = invoicing.address.city
            this.zipCode = invoicing.address.zipCode
            this.country = invoicing.address.country
            this.paymentIban = invoicing.payment.iban
            this.paymentBic = invoicing.payment.bic
            this.paymentMode = invoicing.payment.mode
            this.paymentMandateDate = invoicing.payment.mandateDate
            this.holderFirstName = invoicing.holder.firstName
            this.holderLastName = invoicing.holder.lastName
            this.holderEmail = invoicing.holder.email
        },
    },
    getters: {
        firstLastName(state: IInvoicingState) : string|null {
            const value = (this.holderFirstName ? this.holderFirstName + ' ' : '') + (this.holderLastName ?? '')
            if (value == '') {
                return null
            }

            return value
        },
        lastFirstName(state: IInvoicingState) : string|null {
            const value = (this.holderLastName ? this.holderLastName + ' ' : '') + (this.holderFirstName ?? '')
            if (value == '') {
                return null
            }

            return value
        },
        paymentCurrentMode(state: IInvoicingState) : string|null {
            return state.paymentMode && state.paymentMode != '' ? state.paymentMode : null
        },
        paymentIbanNumber(state: IInvoicingState) : string|null {
            return state.paymentIban && state.paymentIban != '' ? state.paymentIban : null
        },
        paymentBicNumber(state: IInvoicingState) : string|null {
            return state.paymentBic && state.paymentBic != '' ? state.paymentBic : null
        },
        currentMandateDate(state: IInvoicingState) : string|null {
            return state.paymentMandateDate ?? null
        }
    },
    persist: true,
})

interface IInvoicingState {
    id: number,
    street: string|null,
    streetNumber: string|null,
    box: string|null,
    city: string|null,
    zipCode: string|null,
    country: string|null,
    paymentMode: string|null,
    paymentIban: string|null,
    paymentBic: string|null,
    paymentMandateDate: string|null
    holderFirstName: string|null,
    holderLastName: string|null,
    holderEmail: string|null,
}

export type InvoicingStore = ReturnType<typeof useInvoicingStore>